import * as Sentry from '@sentry/react';
import type { RouterHistory } from '@sentry/react/build/types-ts3.8/reactrouter';
import { matchPath } from 'react-router';
import { history } from './routeHistory';

const tracingRoutes = [
	{ path: '/communication-center' },
	{ path: '/search-businesses' },
	{ path: '/activity-reports' },
	{ path: '/scheduled-emails' },
	{ path: '/lists' },
	{ path: '/lists/details/:id' },
	{ path: '/sequences' },
	{ path: '/demand-reports' },
	{ path: '/admin' },
	{ path: '/ai-prompts' },
	{ path: '/verify-email-onboarding' },
	{ path: '/reactivation' },
];

export const initMonitoringLog = () => {
	const isSentryActive = Sentry.getClient() !== undefined;

	if (isSentryActive) return;

	Sentry.init({
		environment: process.env.NODE_ENV,
		dsn: process.env.SENTRY_DNS,
		sendDefaultPii: true, // Controls if potentially sensitive data should be sent to Sentry by default. Docs: https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii

		integrations: [
			Sentry.reactRouterV5BrowserTracingIntegration({
				history: history as unknown as RouterHistory,
				routes: tracingRoutes,
				matchPath
			}),

			Sentry.replayIntegration({
				// NOTE: This will disable built-in masking. Only use this if your site has no sensitive data, or if you've already set up other options for masking or blocking relevant data, such as 'ignore', 'block', 'mask' and 'maskFn'.
				maskAllText: false,
				blockAllMedia: false
			})
		],

		// Traces
		tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.25 : 1.0,

		// Session Replay
		replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	});
};
